import { render, staticRenderFns } from "./AdminSystemChat.vue?vue&type=template&id=05908a5a"
import script from "./AdminSystemChat.vue?vue&type=script&lang=js"
export * from "./AdminSystemChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports